import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OtherProfileData } from "@src/constants";

// Define the types for the payload of registrationRequest
interface RegistrationPayload {
    first_name: string;
    last_name?: string;
    gender?: string;
    age?:number|string;
    is_doctor?: boolean; // Optional field, default is false
    specialty?: string;
    credentials?:string;
    country?: string;
    npi?: string;
    license?: string;
    license_state?: string;
    demographics?: OtherProfileData;
  }

interface AuthState {
    loading: boolean;
    error: string | null;
    refreshToken: string | null;
    accessToken: string | null;
    successMessage: string | null;
}

const initialState: AuthState = {
    loading: false,
    error: null,
    refreshToken: null,
    accessToken: null,
    successMessage: null,
};

const signSlice = createSlice({
    name: "sign",
    initialState,
    reducers: {
        // Expecting the payload type of { first_name, last_name, email, gender, password }
        registrationRequest: (state, action: PayloadAction<RegistrationPayload>) => {
            state.loading = true;
            state.error = null;
            state.successMessage = null;
        },
        registrationSuccess: (
            state,
            action: PayloadAction<{ accessToken: string; refreshToken: string; message: string }>,
        ) => {
            state.loading = false;
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
            state.successMessage = action.payload.message;
        },
        registrationFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
        clearRegisterError: (state) => {
            state.error = null; // or ''
        },
    },
});

export const { registrationRequest, registrationSuccess, registrationFailure, clearRegisterError } = signSlice.actions;
export const signReducer = signSlice.reducer;
export const signActionTypes = signSlice.actions;
